// import styled from "@emotion/styled";
import LoadingButton from "@mui/lab/LoadingButton";
import { ReactNode } from "react";
interface SignButtonProps {
	text: string;
	onClick?: () => void;
	type?: "submit" | "button";
	loading?: boolean;
	className?: string;
	endIcon?: ReactNode;
	disabled?: boolean;
}

const SignButton = (props: SignButtonProps) => {
	const { text, onClick, type, loading, className, endIcon, disabled } = props;
	return (
		<LoadingButton
			type={type || "button"}
			className={className || ""}
			loading={loading}
			onClick={onClick}
			fullWidth
			variant="contained"
			disabled={disabled}
			sx={{
				background: "var(--primary)",
				height: "45px",
				fontWeight: 700,
				fontSize: "20px",
				lineHeight: "20px",
				borderRadius: "63px",
			}}
			endIcon={endIcon}
		>
			{text}
		</LoadingButton>
	);
};

export default SignButton;
